/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Container, Grid, Box, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import collections from '../../constants/FirestoreCollections';
import { useFirestore } from 'react-redux-firebase';
import Kpis from './components/Kpis';
import ChartsHealth from './components/Charts/ChartsHealth';
import ChartsSales from './components/Charts/ChartsSales';

export default function Graphics() {
  const [info, setInfo] = useState(null);
  const [date, setDate] = useState('');

  const firestore = useFirestore();

  const organization = useSelector((state) => state.app.organization);

  const healthSoftware =
    organization && organization.services && organization.services.healthSoftware;
  const salesSoftware = organization?.services?.salesSoftware;
  const healthDecisionSoftware = organization?.services?.healthDecisionSoftware;
  const useStyles = () => {
    return makeStyles((theme) => ({
      appBarSpacer: theme.mixins.toolbar,
      chartContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(4),
      },
    }));
  };

  const fetchDataFromFirestore = async () => {
    try {
      if (date !== '' && date._isValid) {
        const billingRes = await firestore
          .collection(collections.bills)
          .where('organizationId', '==', organization.id)
          .where('date', '==', date.format('YYYY-MM'))
          .get();
        if (!billingRes.empty) {
          const bill = { ...billingRes.docs[0].data(), id: billingRes.docs[0].id };
          setInfo(bill);
        } else {
          setInfo({});
          setDate('');
          console.log('no se encontro bill');
        }
      }
    } catch (err) {
      console.log('Error en useEffect [refreshBill]', err);
    }
  };

  useEffect(async () => {
    await fetchDataFromFirestore();
  }, [date, organization]);

  const getAndParseLocalStorageDate = () =>
    localStorage.getItem('date') ? JSON.parse(localStorage.getItem('date')) : false;

  useEffect(() => {
    if (localStorage.getItem('date')) {
      const formatLocalStorageDate = getAndParseLocalStorageDate().replace(
        /(\d{4})-(\d{2})/,
        '$1/$2/01',
      );
      setDate(moment(new Date(formatLocalStorageDate)));
    }
  }, []);

  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  return (
    <Container maxWidth="lg">
      <Box pb={4}>
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} sm={10}>
            {(salesSoftware || healthDecisionSoftware) && <div className={classes.appBarSpacer} />}
            <Container maxWidth="lg">
              {healthSoftware && <Kpis />}
              {healthSoftware && info && <ChartsHealth />}
              {(salesSoftware || healthDecisionSoftware) && <ChartsSales />}
            </Container>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
